<template>
  <div class="content-container">
    <van-nav-bar
      :title="navTitle"
      left-arrow
      @click-left="onClickBack"
      @click-right="onBatchAll"
      :right-text="navRightText"
    />
    <div class="notice">{{$t('message.workRecycleNotice')}}</div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoadMore" :immediate-check="false">
        <van-checkbox-group ref="checkboxGroup" v-model="selectedRowKeys">
          <div class="material-wrapper" v-for="(material,index) in materialList" :key="material.id">
            <div class="info-wrapper">
              <div class="left-wrapper">
                <div>
                  <img
                    style="width: 40px; height: 40px"
                    v-if="material.belong==='pano'"
                    :src="material.thumb_path"
                  />
                  <img
                    style="width: 40px; height: 40px"
                    v-if="material.type===1"
                    :src="material.url"
                  />
                  <img
                    style="width: 40px; height: 40px"
                    v-if="material.type===2"
                    src="@/assets/img/music.png"
                  />
                  <img
                    style="width: 40px; height: 40px"
                    v-if="material.type===3"
                    src="@/assets/img/video.png"
                  />
                </div>
                <div class="material-info">
                  <div class="info-title">{{material.name?material.name:material.filename}}</div>
                  <div class="info-description">{{material.create_time+" "+material.filesize }}</div>
                </div>
              </div>
              <div class="right-wrapper" @click="toggle(index)">
                <van-checkbox ref="checkboxes" :name="material.id" :icon-size="16" />
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </van-pull-refresh>
    <batch-operate
      :selected-keys="selectedRowKeys"
      @close="selectedRowKeys=[]"
      @all="onBatchAllEmpty"
    >
      <batch-operate-item :text="$t('actionTitles.delete')" @click="batchOperation('delete')">
        <template v-slot:icon>
          <a-icon type="delete" />
        </template>
      </batch-operate-item>
      <batch-operate-item :text="$t('actionTitles.resume')" @click="batchOperation('regain')">
        <template v-slot:icon>
          <a-icon type="retweet" />
        </template>
      </batch-operate-item>
    </batch-operate>
  </div>
</template>
<script>
import Vue from "vue";
import { recycle, materialDelete, regain } from "@/api/planeMaterial";
import { recycleDelete } from "@/api/material";
import BatchOperate from "../../components/BatchOperate";
import BatchOperateItem from "../../components/BatchOperateItem";
import { List, PullRefresh, NavBar, Checkbox, CheckboxGroup, Icon } from "vant";
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(NavBar);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(CheckboxGroup);
export default {
  components: { BatchOperate, BatchOperateItem },
  data() {
    return {
      navTitle: this.$t('moduleTitles.recycle'),
      navRightText: this.$t('actionTitles.selectAll'),

      refreshing: false,
      loading: false,
      finished: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {
        current_page: null,
        per_page: null,
      },
      selectedRowKeys: [],
      materialList: [],
      showSelectAll: true,
    };
  },
  created() {},
  mounted() {
    this.onRefresh();
  },
  methods: {
    onClickBack() {
      this.$router.back();
    },
    onRefresh() {
      this.selectedRowKeys = [];
      this.pagination.current = 1;
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      this.loadData();
    },
    onLoadMore() {
      this.pagination.current += 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };
      recycle(this.searchParam).then((ret) => {
        this.loading = false;
        if (ret.code == 1 && ret.data.records.length) {
          if (this.refreshing) {
            this.materialList = ret.data.records;
          } else {
            this.materialList = [...this.materialList, ...ret.data.records];
          }
          this.refreshing = false;

          if (ret.data.records.length < this.pagination.pageSize) {
            this.finished = true;
          }
          this.pagination.total = ret.data.records.total;
        } else {
          this.materialList = [];
          this.finished = true;
        }
      });
    },
    onBatchAll() {
      this.$refs.checkboxGroup.toggleAll(true);
    },
    onBatchAllEmpty() {
      this.$refs.checkboxGroup.toggleAll(false);
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    batchOperation(type) {
      let idList = [];
      this.materialList.forEach((item) => {
        if (this.selectedRowKeys.some((key) => key === item.id)) {
          idList.push({ id: item.id, type: item.belong });
        }
      });
      if (type === "delete") {
        materialDelete(idList).then((res) => {
          if (res.code === 1) {
            this.onRefresh();
            this.$message.success(this.$i18n.t("message.deleteSuccess"));
          }
        });
      } else if (type === "regain") {
        regain(idList).then((res) => {
          if (res.code === 1) {
            this.onRefresh();
            this.$message.success(this.$i18n.t("message.regainSuccess"));
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content-container {
  background-color: #fff;
  min-height: 100vh;
}
.notice {
  padding: 10px;
  background-color: #fdfafa;
  font-size: 13px;
}

.material-wrapper {
  padding: 0px 10px 0px 10px;
  width: 100vw;

  .info-wrapper {
    padding: 10px 0px 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #efeeee;
    .left-wrapper {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
    }
    .right-wrapper{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .material-info {
      margin-left: 10px;
    }
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 100;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
    }
  }
}
</style>
